var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDeclare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 711,
    viewBox: "0 0 375 711",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_11490_32622)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 145.5,
    cy: 335.5,
    r: 87.5,
    fill: "#0054A3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145.5,
    cy: 335.5,
    r: 87.5,
    fill: "#0054A3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145.5,
    cy: 335.5,
    r: 87.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145.5,
    cy: 335.5,
    r: 87.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145.5,
    cy: 335.5,
    r: 87.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145.5,
    cy: 335.5,
    r: 87.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145.5,
    cy: 335.5,
    r: 87.5,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_11490_32622)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 263,
    cy: 309,
    r: 73,
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_11490_32622)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 271,
    r: 73,
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_11490_32622)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 330,
    r: 73,
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_11490_32622)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 93,
    cy: 330,
    r: 73,
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_11490_32622)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 228,
    cy: 214,
    r: 73,
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_11490_32622)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 233,
    cy: 403,
    r: 73,
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_11490_32622)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 330,
    r: 73,
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_11490_32622)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 344,
    r: 73,
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_11490_32622)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 179,
    cy: 403,
    r: 73,
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_11490_32622)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 282,
    r: 73,
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11490_32622)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_11490_32622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.878 174.322H104.422C98.4884 174.322 93.6782 179.126 93.6782 185.052V404.942C93.6782 410.867 98.4884 415.671 104.422 415.671H259.878C265.812 415.671 270.622 410.867 270.622 404.942V185.052C270.622 179.126 265.812 174.322 259.878 174.322Z",
    fill: "#0074EB"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M256.208 192.206H108.093C106.532 192.206 105.267 193.47 105.267 195.028V399.122C105.267 400.681 106.532 401.944 108.093 401.944H256.208C257.769 401.944 259.034 400.681 259.034 399.122V195.028C259.034 193.47 257.769 192.206 256.208 192.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M182.997 449.299C238.225 449.299 282.995 444.531 282.995 438.649C282.995 432.768 238.225 428 182.997 428C127.77 428 83 432.768 83 438.649C83 444.531 127.77 449.299 182.997 449.299Z",
    fill: "#0074E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.88 167.599H205.264V152.602C205.264 148.404 201.569 145 197.014 145H171.55C166.99 145 163.3 148.404 163.3 152.602V167.599H136.568C136.055 167.58 135.555 167.765 135.178 168.113C134.801 168.461 134.578 168.944 134.557 169.457V194.17C134.585 194.842 134.878 195.476 135.373 195.932C135.868 196.389 136.523 196.631 137.197 196.605H231.714C232.305 196.626 232.881 196.414 233.315 196.013C233.749 195.612 234.007 195.056 234.032 194.466V169.592C234.01 169.044 233.771 168.526 233.368 168.152C232.964 167.779 232.43 167.58 231.88 167.599ZM185.204 165.274C180.68 165.802 176.849 162.262 177.417 158.1C177.809 155.248 180.308 152.943 183.4 152.577C187.924 152.049 191.755 155.589 191.182 159.751C190.785 162.613 188.286 164.923 185.194 165.274H185.204Z",
    fill: "#0054A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.95 244.032C143.266 244.032 150.007 237.3 150.007 228.995C150.007 220.69 143.266 213.957 134.95 213.957C126.634 213.957 119.892 220.69 119.892 228.995C119.892 237.3 126.634 244.032 134.95 244.032Z",
    fill: "#009CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.225 238.544C132.58 238.544 131.961 238.287 131.506 237.831L125.664 231.997C125.424 231.774 125.232 231.505 125.099 231.207C124.966 230.908 124.895 230.586 124.889 230.26C124.883 229.933 124.943 229.608 125.066 229.305C125.188 229.002 125.37 228.727 125.602 228.496C125.833 228.265 126.108 228.082 126.411 227.96C126.715 227.837 127.039 227.776 127.367 227.782C127.694 227.787 128.016 227.858 128.315 227.99C128.614 228.123 128.884 228.314 129.107 228.553L132.938 232.379L140.545 221.995C140.927 221.474 141.501 221.126 142.14 221.027C142.779 220.928 143.432 221.087 143.954 221.468C144.476 221.85 144.825 222.423 144.924 223.061C145.023 223.699 144.864 224.351 144.482 224.872L135.196 237.545C134.989 237.831 134.723 238.068 134.416 238.242C134.109 238.415 133.768 238.52 133.416 238.549L133.225 238.544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.95 288.06C143.266 288.06 150.007 281.328 150.007 273.023C150.007 264.718 143.266 257.985 134.95 257.985C126.634 257.985 119.892 264.718 119.892 273.023C119.892 281.328 126.634 288.06 134.95 288.06Z",
    fill: "#009CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.225 282.567C132.58 282.567 131.961 282.31 131.505 281.854L125.663 276.02C125.207 275.564 124.95 274.946 124.95 274.301C124.95 273.656 125.207 273.037 125.663 272.581C126.12 272.125 126.74 271.869 127.385 271.869C128.031 271.869 128.651 272.125 129.107 272.581L132.938 276.387L140.545 266.009C140.933 265.506 141.503 265.174 142.132 265.084C142.761 264.995 143.401 265.154 143.914 265.529C144.428 265.903 144.774 266.463 144.88 267.09C144.986 267.716 144.843 268.358 144.481 268.88L135.196 281.558C134.989 281.844 134.723 282.081 134.416 282.255C134.109 282.428 133.767 282.533 133.416 282.562L133.225 282.567Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.95 332.084C141.266 332.084 148.007 325.351 148.007 317.046C148.007 308.741 141.266 302.008 132.95 302.008C124.634 302.008 117.892 308.741 117.892 317.046C117.892 325.351 124.634 332.084 132.95 332.084Z",
    fill: "#009CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.336 326.566C130.691 326.566 130.073 326.309 129.617 325.853L123.775 320.039C123.536 319.816 123.344 319.548 123.211 319.249C123.078 318.951 123.006 318.628 123 318.302C122.995 317.975 123.055 317.651 123.177 317.348C123.3 317.045 123.482 316.769 123.713 316.538C123.944 316.307 124.219 316.124 124.523 316.002C124.826 315.879 125.151 315.819 125.478 315.824C125.805 315.829 126.128 315.9 126.427 316.033C126.726 316.165 126.995 316.356 127.219 316.595L131.05 320.421L138.656 309.997C139.038 309.476 139.612 309.128 140.251 309.029C140.891 308.93 141.543 309.089 142.065 309.47C142.587 309.852 142.936 310.425 143.035 311.063C143.134 311.701 142.975 312.353 142.593 312.874L133.307 325.562C133.1 325.848 132.834 326.085 132.527 326.259C132.22 326.432 131.879 326.537 131.527 326.566H131.336Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.95 376.112C143.266 376.112 150.007 369.379 150.007 361.074C150.007 352.769 143.266 346.037 134.95 346.037C126.634 346.037 119.892 352.769 119.892 361.074C119.892 369.379 126.634 376.112 134.95 376.112Z",
    fill: "#009CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.225 370.619C132.58 370.618 131.961 370.362 131.505 369.906L125.663 364.072C125.437 363.846 125.258 363.578 125.136 363.283C125.013 362.988 124.95 362.671 124.95 362.352C124.95 362.033 125.013 361.716 125.136 361.421C125.258 361.126 125.437 360.858 125.663 360.632C125.89 360.406 126.158 360.227 126.453 360.105C126.749 359.983 127.066 359.92 127.385 359.92C127.705 359.92 128.022 359.983 128.317 360.105C128.613 360.227 128.881 360.406 129.107 360.632L132.938 364.453L140.545 354.075C140.933 353.572 141.503 353.241 142.132 353.151C142.761 353.061 143.401 353.221 143.914 353.595C144.428 353.97 144.774 354.53 144.88 355.156C144.986 355.782 144.843 356.425 144.481 356.947L135.196 369.625C134.989 369.91 134.723 370.148 134.416 370.321C134.109 370.494 133.767 370.599 133.416 370.629L133.225 370.619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.195 226.293H168.569C167.563 226.293 166.713 225.224 166.713 223.898C166.713 222.578 167.543 221.503 168.569 221.503H239.195C240.201 221.503 241.045 222.578 241.045 223.898C241.045 225.224 240.216 226.293 239.195 226.293Z",
    fill: "#0054A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.035 236.692H168.252C167.503 236.692 166.895 235.617 166.895 234.297C166.895 232.971 167.503 231.902 168.252 231.902H220.035C220.785 231.902 221.393 232.971 221.393 234.297C221.393 235.617 220.785 236.692 220.035 236.692Z",
    fill: "#009CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.196 271.235H167.824C167.211 271.235 166.713 270.166 166.713 268.84C166.713 267.52 167.216 266.445 167.824 266.445H210.196C210.81 266.445 211.308 267.52 211.308 268.84C211.308 270.166 210.81 271.235 210.196 271.235Z",
    fill: "#009CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.004 280.097H168.739C167.734 280.097 166.899 279.028 166.899 277.702C166.899 276.382 167.724 275.307 168.739 275.307H239.004C240.01 275.307 240.844 276.382 240.844 277.702C240.844 279.028 240.02 280.097 239.004 280.097Z",
    fill: "#0054A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.632 314.646H168.564C167.558 314.646 166.724 313.571 166.724 312.246C166.724 310.925 167.548 309.851 168.564 309.851H238.632C239.638 309.851 240.467 310.925 240.467 312.246C240.467 313.571 239.643 314.646 238.632 314.646Z",
    fill: "#009CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.388 324.271H168.418C167.478 324.271 166.713 323.197 166.713 321.876C166.713 320.551 167.478 319.476 168.418 319.476H233.388C234.329 319.476 235.088 320.551 235.088 321.876C235.108 323.197 234.349 324.271 233.388 324.271Z",
    fill: "#0054A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.585 358.815H168.202C167.387 358.815 166.724 357.74 166.724 356.42C166.724 355.094 167.387 354.025 168.202 354.025H224.585C225.4 354.025 226.058 355.094 226.058 356.42C226.058 357.725 225.4 358.815 224.585 358.815Z",
    fill: "#009CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.823 368.44H168.558C167.553 368.44 166.713 367.365 166.713 366.045C166.713 364.719 167.538 363.65 168.558 363.65H238.823C239.829 363.65 240.663 364.719 240.663 366.045C240.663 367.365 239.839 368.44 238.823 368.44Z",
    fill: "#0054A8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133,
    cy: 317,
    r: 19,
    stroke: "#0074E4",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.5323 147.724L64.9057 144.58L65.4625 138.041C65.4767 137.874 65.5345 137.715 65.6295 137.582C65.7245 137.449 65.8529 137.347 66.0002 137.289C66.1474 137.23 66.3076 137.217 66.4628 137.251C66.6179 137.284 66.7616 137.363 66.8779 137.479L71.4172 141.996L77.4291 140.624C77.5837 140.588 77.7453 140.599 77.8955 140.656C78.0457 140.713 78.1784 140.813 78.2785 140.946C78.3786 141.079 78.4419 141.239 78.4614 141.407C78.4808 141.575 78.4555 141.745 78.3884 141.897L75.8163 147.835L78.9659 153.521C79.0462 153.666 79.0871 153.833 79.0841 154.001C79.0811 154.169 79.0342 154.332 78.9487 154.472C78.8633 154.612 78.7426 154.723 78.6002 154.793C78.4579 154.864 78.2994 154.89 78.1426 154.869L72.0294 154.039L67.9723 158.937C67.8678 159.062 67.7324 159.153 67.5811 159.2C67.4298 159.247 67.2687 159.247 67.1159 159.202C66.9632 159.156 66.8248 159.066 66.7164 158.942C66.608 158.817 66.5339 158.664 66.5024 158.498L65.2798 152.004L59.6131 149.338C59.4695 149.269 59.3462 149.158 59.257 149.019C59.1678 148.88 59.1161 148.718 59.1078 148.551C59.0994 148.384 59.1346 148.218 59.2096 148.072C59.2845 147.926 59.3962 147.806 59.5323 147.724Z",
    fill: "#0074E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.727 109.014L126.204 105.519L126.947 98.3715C126.965 98.1886 127.037 98.0141 127.152 97.8678C127.267 97.7215 127.422 97.6092 127.6 97.5436C127.777 97.478 127.969 97.4617 128.155 97.4966C128.34 97.5315 128.512 97.6162 128.65 97.7411L134.04 102.623L141.262 101.055C141.448 101.014 141.642 101.024 141.821 101.084C142.001 101.145 142.159 101.253 142.277 101.397C142.395 101.541 142.47 101.715 142.491 101.898C142.512 102.082 142.48 102.268 142.398 102.435L139.247 108.949L142.957 115.122C143.052 115.281 143.099 115.462 143.094 115.645C143.088 115.829 143.03 116.007 142.926 116.161C142.822 116.315 142.676 116.438 142.504 116.516C142.333 116.595 142.143 116.625 141.955 116.605L134.636 115.767L129.716 121.164C129.59 121.301 129.426 121.402 129.244 121.455C129.063 121.508 128.869 121.51 128.687 121.462C128.504 121.414 128.339 121.317 128.211 121.183C128.082 121.048 127.995 120.881 127.959 120.701L126.568 113.622L119.805 110.776C119.634 110.701 119.487 110.582 119.382 110.431C119.277 110.281 119.217 110.104 119.208 109.922C119.2 109.739 119.244 109.558 119.336 109.398C119.427 109.237 119.563 109.105 119.727 109.014Z",
    fill: "#FF724F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_11490_32622",
    x: -177,
    y: 13,
    width: 645,
    height: 645,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 117.5,
    result: "effect1_foregroundBlur_11490_32622"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_11490_32622",
    x: -45,
    y: 1,
    width: 616,
    height: 616,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 117.5,
    result: "effect1_foregroundBlur_11490_32622"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_11490_32622",
    x: -44,
    y: -37,
    width: 616,
    height: 616,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 117.5,
    result: "effect1_foregroundBlur_11490_32622"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_11490_32622",
    x: -110,
    y: 22,
    width: 616,
    height: 616,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 117.5,
    result: "effect1_foregroundBlur_11490_32622"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_11490_32622",
    x: -215,
    y: 22,
    width: 616,
    height: 616,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 117.5,
    result: "effect1_foregroundBlur_11490_32622"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_11490_32622",
    x: -80,
    y: -94,
    width: 616,
    height: 616,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 117.5,
    result: "effect1_foregroundBlur_11490_32622"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_11490_32622",
    x: -75,
    y: 95,
    width: 616,
    height: 616,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 117.5,
    result: "effect1_foregroundBlur_11490_32622"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_11490_32622",
    x: 2,
    y: 22,
    width: 616,
    height: 616,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 117.5,
    result: "effect1_foregroundBlur_11490_32622"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_11490_32622",
    x: -266,
    y: 36,
    width: 616,
    height: 616,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 117.5,
    result: "effect1_foregroundBlur_11490_32622"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_11490_32622",
    x: -129,
    y: 95,
    width: 616,
    height: 616,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 117.5,
    result: "effect1_foregroundBlur_11490_32622"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_11490_32622",
    x: -156,
    y: -26,
    width: 616,
    height: 616,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 117.5,
    result: "effect1_foregroundBlur_11490_32622"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_11490_32622",
    x: 89.6782,
    y: 174.322,
    width: 184.944,
    height: 249.349,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11490_32622"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11490_32622",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11490_32622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 304,
    fill: "white",
    transform: "translate(83 145)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeclare);
export default __webpack_public_path__ + "static/media/iconDeclare.97e2650576c8b0579202fb8527a97709.svg";
export { ForwardRef as ReactComponent };